<!--
  Ventana flotante de redacción (tipo Gmail). Anclada abajo-derecha, por encima
  de todo (z-modal). Sin backdrop: no bloquea el resto de la app (se puede
  seguir navegando). Se monta UNA vez en el shell.
-->
@if (isOpen) {
<div
  class="fixed bottom-0 right-0 z-modal flex w-full flex-col overflow-hidden rounded-t-xl border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900 sm:bottom-4 sm:right-4 sm:w-[540px] sm:max-w-[calc(100vw-2rem)] sm:rounded-xl"
  [ngClass]="minimized ? '' : 'h-[600px] max-h-[calc(100vh-2rem)]'">

  <!-- Barra de título (clic = minimizar/restaurar) -->
  <div
    class="flex shrink-0 cursor-pointer items-center justify-between bg-gray-800 px-4 py-2.5 text-white dark:bg-gray-950"
    (click)="toggleMinimize()">
    <h2 class="truncate text-sm font-semibold">
      {{ subject.trim() || 'Mensaje nuevo' }}
    </h2>
    <div class="flex items-center gap-1">
      <!-- Minimizar / Restaurar -->
      <button type="button" (click)="$event.stopPropagation(); toggleMinimize()"
        class="rounded p-1 text-gray-300 transition-colors hover:bg-white/10 hover:text-white"
        [title]="minimized ? 'Restaurar' : 'Minimizar'">
        @if (minimized) {
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4" />
        </svg>
        } @else {
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14" />
        </svg>
        }
      </button>
      <!-- Cerrar -->
      <button type="button" (click)="$event.stopPropagation(); close()" [disabled]="sending"
        class="rounded p-1 text-gray-300 transition-colors hover:bg-white/10 hover:text-white disabled:opacity-50"
        title="Cerrar">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>

  @if (!minimized) {
  <!-- Cuerpo del formulario (scrollable) -->
  <div class="flex-1 overflow-y-auto px-4 py-3">

    <!-- Error inline -->
    @if (errorMessage) {
    <div class="mb-3 rounded-lg border border-error-200 bg-error-50 p-2.5 dark:border-error-500/20 dark:bg-error-500/10">
      <p class="text-xs text-error-600 dark:text-error-400">{{ errorMessage }}</p>
    </div>
    }

    <!-- Para (destinatarios) — chips + typeahead -->
    <div class="mb-2 border-b border-gray-100 pb-2 dark:border-gray-800">
      <div class="relative">
        <div class="flex items-start gap-2">
          <span class="mt-1.5 shrink-0 text-xs font-medium text-gray-500 dark:text-gray-400">Para</span>
          <div class="flex flex-1 flex-wrap items-center gap-1.5">
            @for (r of recipients; track r.email) {
            <span class="inline-flex max-w-full items-center gap-1 rounded-full border border-brand-200 bg-brand-50 py-0.5 pl-2 pr-1 text-xs dark:border-brand-500/30 dark:bg-brand-500/10"
              [title]="r.email">
              <span class="max-w-[190px] truncate font-medium text-brand-700 dark:text-brand-300">{{ recipientLabel(r) }}</span>
              @if (r.idContact !== null) {
              <span class="shrink-0 rounded-full bg-brand-100 px-1.5 text-[9px] font-medium text-brand-600 dark:bg-brand-500/20 dark:text-brand-300">Contacto</span>
              }
              <button type="button" (click)="quitarDestinatario(r)" title="Quitar destinatario"
                class="shrink-0 rounded-full p-0.5 text-brand-500 hover:bg-brand-100 dark:hover:bg-brand-500/20">
                <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </span>
            }
            <input
              type="text"
              [(ngModel)]="toQuery"
              (ngModelChange)="onToQueryChange()"
              (keyup.enter)="usarCorreoLibre()"
              [placeholder]="recipients.length ? 'Añadir otro…' : 'Nombre del contacto o correo...'"
              class="h-7 min-w-[130px] flex-1 border-0 bg-transparent px-0 text-sm text-gray-800 placeholder:text-gray-400 focus:outline-hidden focus:ring-0 dark:text-white/90 dark:placeholder:text-white/30"
            />
          </div>
          <!-- Revelar CC / CCO tipo Gmail -->
          <div class="mt-1 flex shrink-0 items-center gap-2 text-xs font-medium text-gray-400 dark:text-gray-500">
            @if (!showCc) {
            <button type="button" (click)="showCc = true" class="hover:text-brand-500">Cc</button>
            }
            @if (!showBcc) {
            <button type="button" (click)="showBcc = true" class="hover:text-brand-500">Cco</button>
            }
          </div>
        </div>

        @if (showResults && toQuery.trim().length >= 2) {
        <div class="absolute left-0 right-0 z-modal-top mt-1 rounded-lg border border-gray-200 bg-white shadow-theme-lg dark:border-gray-700 dark:bg-gray-900">
          <div class="max-h-56 overflow-y-auto py-1">
            @if (contactSearching) {
            <div class="flex items-center gap-2 px-3 py-2 text-xs text-gray-400">
              <span class="h-3.5 w-3.5 animate-spin rounded-full border-b-2 border-brand-500"></span>
              Buscando contactos…
            </div>
            }
            @for (c of contactResults; track c.id) {
            <button type="button" (click)="seleccionarContacto(c)"
              class="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50 dark:hover:bg-white/[0.03]">
              <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-50 text-[10px] font-semibold text-brand-600 dark:bg-brand-500/10 dark:text-brand-400">
                {{ (c.fullname || c.mail || '?').substring(0, 2).toUpperCase() }}
              </div>
              <div class="min-w-0">
                <p class="truncate text-sm text-gray-800 dark:text-white/90">{{ c.fullname || '(sin nombre)' }}</p>
                <p class="truncate text-xs text-gray-400 dark:text-gray-500">{{ c.mail }}</p>
              </div>
            </button>
            }
            @if (!contactSearching && contactResults.length === 0) {
            <button type="button" (click)="usarCorreoLibre()"
              class="flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-gray-50 dark:hover:bg-white/[0.03]">
              <svg class="h-4 w-4 shrink-0 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
              </svg>
              <span class="truncate text-sm text-gray-700 dark:text-gray-300">Usar correo "<span class="font-medium">{{ toQuery.trim() }}</span>"</span>
            </button>
            }
          </div>
        </div>
        }
      </div>
      @if (tieneTextoSinConfirmar) {
      <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">Elige un contacto o presiona Enter para añadir el correo escrito.</p>
      }
    </div>

    <!-- CC -->
    @if (showCc) {
    <div class="mb-2 border-b border-gray-100 pb-2 dark:border-gray-800">
      <div class="flex items-center gap-2">
        <span class="shrink-0 text-xs font-medium text-gray-500 dark:text-gray-400">Cc</span>
        <input
          type="text"
          [(ngModel)]="ccRaw"
          placeholder="correo1@ejemplo.com, correo2@ejemplo.com"
          class="h-8 w-full border-0 bg-transparent px-0 text-sm text-gray-800 placeholder:text-gray-400 focus:outline-hidden focus:ring-0 dark:text-white/90 dark:placeholder:text-white/30"
        />
      </div>
    </div>
    }

    <!-- CCO -->
    @if (showBcc) {
    <div class="mb-2 border-b border-gray-100 pb-2 dark:border-gray-800">
      <div class="flex items-center gap-2">
        <span class="shrink-0 text-xs font-medium text-gray-500 dark:text-gray-400">Cco</span>
        <input
          type="text"
          [(ngModel)]="bccRaw"
          placeholder="correo1@ejemplo.com, correo2@ejemplo.com"
          class="h-8 w-full border-0 bg-transparent px-0 text-sm text-gray-800 placeholder:text-gray-400 focus:outline-hidden focus:ring-0 dark:text-white/90 dark:placeholder:text-white/30"
        />
      </div>
    </div>
    }

    <!-- Asunto -->
    <div class="mb-2 border-b border-gray-100 pb-2 dark:border-gray-800">
      <input
        type="text"
        [(ngModel)]="subject"
        maxlength="500"
        placeholder="Asunto"
        class="h-8 w-full border-0 bg-transparent px-0 text-sm font-medium text-gray-800 placeholder:text-gray-400 focus:outline-hidden focus:ring-0 dark:text-white/90 dark:placeholder:text-white/30"
      />
    </div>

    <!-- Editor de texto enriquecido -->
    <div class="mb-2 overflow-visible rounded-lg border border-gray-200 dark:border-gray-700">
      <!-- Barra de herramientas -->
      <div class="relative flex flex-wrap items-center gap-0.5 border-b border-gray-100 p-1 dark:border-gray-800">
        <!-- Fuente / tamaño -->
        <select (mousedown)="guardarSeleccion()" (change)="aplicarFuente($event)"
          class="h-7 rounded border border-gray-200 bg-white px-1 text-xs text-gray-600 focus:outline-hidden dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          title="Tipo de fuente">
          <option value="">Fuente</option>
          @for (f of fonts; track f.value) {
          <option [value]="f.value">{{ f.label }}</option>
          }
        </select>
        <select (mousedown)="guardarSeleccion()" (change)="aplicarTamano($event)"
          class="h-7 rounded border border-gray-200 bg-white px-1 text-xs text-gray-600 focus:outline-hidden dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          title="Tamaño de fuente">
          <option value="">Tamaño</option>
          @for (s of fontSizes; track s.value) {
          <option [value]="s.value">{{ s.label }}</option>
          }
        </select>

        <span class="mx-0.5 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('bold')" title="Negrita"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"><span class="text-sm font-bold">B</span></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('italic')" title="Cursiva"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"><span class="text-sm italic">I</span></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('underline')" title="Subrayado"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"><span class="text-sm underline">U</span></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('strikeThrough')" title="Tachado"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"><span class="text-sm line-through">S</span></button>

        <!-- Color de texto -->
        <label title="Color de texto"
          class="relative flex h-7 w-7 cursor-pointer items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <span class="text-sm font-semibold underline decoration-2">A</span>
          <input type="color" (mousedown)="guardarSeleccion()" (input)="aplicarColorTexto($event)"
            class="absolute inset-0 h-full w-full cursor-pointer opacity-0" />
        </label>
        <!-- Color de resaltado -->
        <label title="Color de resaltado"
          class="relative flex h-7 w-7 cursor-pointer items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
          <input type="color" (mousedown)="guardarSeleccion()" (input)="aplicarResaltado($event)"
            class="absolute inset-0 h-full w-full cursor-pointer opacity-0" />
        </label>

        <span class="mx-0.5 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('justifyLeft')" title="Alinear a la izquierda"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h10M4 18h13"></path></svg></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('justifyCenter')" title="Centrar"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M7 12h10M6 18h12"></path></svg></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('justifyRight')" title="Alinear a la derecha"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M10 12h10M7 18h13"></path></svg></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('justifyFull')" title="Justificar"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg></button>

        <span class="mx-0.5 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('insertUnorderedList')" title="Lista con viñetas"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"></path></svg></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('insertOrderedList')" title="Lista numerada"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 6h13M8 12h13M8 18h13M3 5h1v4M3 9h2M4 15h1a1 1 0 010 2H3"></path></svg></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('outdent')" title="Disminuir sangría"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 8h10M11 12h10M11 16h10M7 8l-4 4 4 4"></path></svg></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="exec('indent')" title="Aumentar sangría"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 8h10M11 12h10M11 16h10M3 8l4 4-4 4"></path></svg></button>
        <button type="button" (mousedown)="$event.preventDefault()" (click)="aplicarCita()" title="Cita"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h6M7 12h4m-4 8l-4-4V6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H7l-4 4z"></path></svg></button>

        <span class="mx-0.5 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

        <button type="button" (mousedown)="$event.preventDefault()" (click)="insertarEnlace()" title="Insertar enlace"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg></button>
        <input #imagenInput type="file" accept="image/*" hidden (change)="onImagenSeleccionada($event)" />
        <button type="button" (mousedown)="$event.preventDefault()" (click)="insertarImagen()" [disabled]="subiendoImagen" title="Insertar imagen"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 disabled:opacity-50 dark:text-gray-300 dark:hover:bg-gray-800">
          @if (subiendoImagen) {
          <span class="h-3.5 w-3.5 animate-spin rounded-full border-b-2 border-brand-500"></span>
          } @else {
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
          }
        </button>

        <!-- Emoji -->
        <button type="button" (mousedown)="$event.preventDefault()" (click)="toggleEmoji()" title="Insertar emoji"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg></button>
        @if (showEmoji) {
        <div class="absolute left-1 top-full z-modal-top mt-1 grid w-56 grid-cols-8 gap-0.5 rounded-lg border border-gray-200 bg-white p-2 shadow-theme-lg dark:border-gray-700 dark:bg-gray-900">
          @for (e of emojis; track e) {
          <button type="button" (mousedown)="$event.preventDefault()" (click)="insertarEmoji(e)"
            class="flex h-6 w-6 items-center justify-center rounded text-base hover:bg-gray-100 dark:hover:bg-gray-800">{{ e }}</button>
          }
        </div>
        }

        <span class="mx-0.5 h-5 w-px bg-gray-200 dark:bg-gray-700"></span>

        <button type="button" (mousedown)="$event.preventDefault()" (click)="quitarFormato()" title="Quitar todo el formato"
          class="flex h-7 w-7 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h11M9 12h11M9 17h6M4 6l2 2m0-2L4 8"></path></svg></button>
      </div>

      <!-- Área editable -->
      <div #editor contenteditable="true"
        (keyup)="guardarSeleccion()"
        (mouseup)="guardarSeleccion()"
        (blur)="guardarSeleccion()"
        data-placeholder="Escribe tu mensaje..."
        class="email-editor min-h-[160px] max-h-[280px] overflow-y-auto px-3 py-2 text-sm text-gray-800 dark:text-white/90"></div>
    </div>

    <!-- Lista de adjuntos -->
    @if (attachments.length > 0) {
    <div class="mt-2 flex flex-wrap gap-2">
      @for (att of attachments; track att.key) {
      <div
        class="flex items-center gap-2 rounded-lg border px-2.5 py-1.5 text-xs"
        [ngClass]="att.error
          ? 'border-error-200 bg-error-50 dark:border-error-500/30 dark:bg-error-500/10'
          : 'border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-white/[0.03]'">
        @if (att.uploading) {
        <span class="h-3.5 w-3.5 animate-spin rounded-full border-b-2 border-brand-500"></span>
        } @else if (att.error) {
        <svg class="h-3.5 w-3.5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M5.07 19h13.86a2 2 0 001.74-3L13.74 4a2 2 0 00-3.48 0L3.33 16a2 2 0 001.74 3z"></path>
        </svg>
        } @else {
        <svg class="h-3.5 w-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
        </svg>
        }
        <div class="min-w-0">
          <p class="max-w-[140px] truncate font-medium"
            [ngClass]="att.error ? 'text-error-600 dark:text-error-400' : 'text-gray-700 dark:text-gray-300'">{{ att.name }}</p>
          <p class="text-[10px] text-gray-400">
            @if (att.error) { Error } @else if (att.uploading) { Subiendo… } @else { {{ formatSize(att.size) }} }
          </p>
        </div>
        <button type="button" (click)="quitarAdjunto(att)" title="Quitar"
          class="shrink-0 rounded p-0.5 text-gray-400 hover:bg-gray-200 hover:text-gray-600 dark:hover:bg-gray-700">
          <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      }
    </div>
    }
  </div>

  <!-- Footer (acciones) -->
  <div class="flex shrink-0 items-center justify-between gap-2 border-t border-gray-200 px-4 py-3 dark:border-gray-700">
    <div class="flex items-center gap-2">
      <!-- Adjuntar -->
      <input #fileInput type="file" multiple hidden (change)="onSeleccionarArchivos($event)" />
      <button type="button" (click)="fileInput.click()" [disabled]="sending"
        class="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
        title="Adjuntar archivos">
        <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"></path>
        </svg>
      </button>
      @if (hayAdjuntosSubiendo) {
      <span class="text-xs text-gray-400">Subiendo adjuntos…</span>
      }
    </div>

    <div class="flex items-center gap-2">
      <button type="button" (click)="close()" [disabled]="sending"
        class="rounded-lg px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50 dark:text-gray-300 dark:hover:bg-white/[0.03]">
        Descartar
      </button>
      <button type="button" (click)="enviar()" [disabled]="!puedeEnviar"
        class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50">
        @if (sending) {
        <span class="h-4 w-4 animate-spin rounded-full border-b-2 border-white"></span>
        Enviando...
        } @else {
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
        </svg>
        Enviar
        }
      </button>
    </div>
  </div>
  }
</div>
}
